var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "treeWrap", class: _vm.prefixCls },
    [
      _vm._l(_vm.stateTree, function(item, i) {
        return _c("Tree-node", {
          key: i,
          attrs: {
            data: item,
            visible: "",
            multiple: _vm.multiple,
            "show-checkbox": _vm.showCheckbox,
            "children-key": _vm.childrenKey
          }
        })
      }),
      _vm._v(" "),
      !_vm.stateTree.length
        ? _c("div", { class: [_vm.prefixCls + "-empty"] }, [
            _vm._v(_vm._s(_vm.localeEmptyText))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ivu-tree-context-menu", style: _vm.contextMenuStyles },
        [
          _c(
            "Dropdown",
            {
              attrs: {
                trigger: "custom",
                visible: _vm.contextMenuVisible,
                transfer: ""
              },
              on: { "on-clickoutside": _vm.handleClickContextMenuOutside }
            },
            [
              _c(
                "DropdownMenu",
                { attrs: { slot: "list" }, slot: "list" },
                [_vm._t("contextMenu")],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d58a3c5", { render: render, staticRenderFns: staticRenderFns })
  }
}